import React from 'react';

const viUpload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path d="M7.16663 13.9835L10.5 10.6501M10.5 10.6501L13.8333 13.9835M10.5 10.6501V18.1501M17.1666 14.6025C18.1845 13.7619 18.8333 12.4901 18.8333 11.0668C18.8333 8.53551 16.7813 6.48348 14.25 6.48348C14.0679 6.48348 13.8975 6.38848 13.8051 6.2316C12.7183 4.38751 10.712 3.15015 8.41663 3.15015C4.96485 3.15015 2.16663 5.94837 2.16663 9.40015C2.16663 11.1219 2.86283 12.681 3.98908 13.8114" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default viUpload;
